export const containerCss = {
  display: "flex",
  justifyContent: "flex-start",
  paddingBottom: "0",
  alignItems: "center",
  lineHeight: 0,
};

export const buttonCss = {
  padding: "0",
  whiteSpace: "nowrap",
};
